interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  checkedBgColor?: string;
}

export function Toggle({
  checked,
  onChange,
  label,
  checkedBgColor = 'bg-orange-500',
}: ToggleProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs leading-5 text-gray-900">{label}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-4 w-9 items-center rounded-full transition-colors cursor-pointer border-none p-0 ${
          checked ? checkedBgColor : 'bg-gray-250v2'
        }`}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white border border-gray-300 transition-transform ${
            checked ? 'translate-x-5' : 'translate-x-0'
          }`}
        />
      </button>
    </div>
  );
}
